import { Injectable } from '@angular/core';
import { Customer } from '@app/core/stingray-api/models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class CustomerService {

  private customer$: BehaviorSubject<Customer> = new BehaviorSubject<Customer>(null);

  private get customer(): Customer {
    return this.customer$.value;
  }

  setCustomer(customer: Customer): void {
    if (this.customer === null || this.customer.id !== customer.id) {
      this.init();
    }

    this.customer$.next(customer);
  }

  getCustomer(): Observable<Customer> {
    return this.customer$.asObservable();
  }

  init(): void {
    this.clearCache();
  }

  /**
   * Clear the customer fields that are cached
   */
  private clearCache(): void {
  }
}
